import React from 'react';
import { ShieldCheckIcon, LockIcon, RefreshCwIcon, HeadphonesIcon } from 'lucide-react';
export function TrustSignals() {
  return <section className="py-12 bg-gray-50 border-t border-gray-200" data-id="element-170">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <div className="flex flex-wrap justify-center gap-8 md:gap-16" data-id="element-172">
          <div className="flex items-center gap-3 text-gray-600" data-id="element-173">
            <LockIcon className="text-brand-emerald" size={24} data-id="element-174" />
            <span className="font-medium" data-id="element-175">Descarga Segura</span>
          </div>
          <div className="flex items-center gap-3 text-gray-600" data-id="element-176">
            <RefreshCwIcon className="text-brand-emerald" size={24} data-id="element-177" />
            <span className="font-medium" data-id="element-178">Acceso de Por Vida</span>
          </div>
          <div className="flex items-center gap-3 text-gray-600" data-id="element-179">
            <HeadphonesIcon className="text-brand-emerald" size={24} data-id="element-180" />
            <span className="font-medium" data-id="element-181">Soporte Incluido</span>
          </div>
          <div className="flex items-center gap-3 text-gray-600" data-id="element-182">
            <ShieldCheckIcon className="text-brand-emerald" size={24} data-id="element-183" />
            <span className="font-medium" data-id="element-184">100% Garantizado</span>
          </div>
        </div>
      </div>
    </section>;
}